import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  basicButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    position: "relative",
    letterSpacing: "1px",
    fontWeight: "bold",
    borderRadius: "8px",
    padding: "15px 20px",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  submitButton: {
    padding: "8px 18px",
    fontWeight: 'bold',
  },
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  upload_zone: {
    fontSize: '0.9rem',
    width: "100%",
    height: "120px",
    padding: '24px 16px',
    border: "2px dashed rgb(209, 209, 209)",
    borderRadius: "4px",
    display: "flex",
    flexDirection: 'column',
    justifyContent: "center",
    alignItems: "center",
    boxShadow: 'none',
    '&:hover': {
      cursor: 'pointer',
      borderColor: 'black'
    }
  },
  images_preview: {
    width: "100%",
    borderRadius: 0,
    objectFit: 'scale-down'
  },
  close_button: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: '#0009',
    color: 'white',
    width: '30px',
    height: '30px',
    padding: '5px',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#000000bf',
      cursor: 'pointer'
    }
  },
  imageList: {
    flexWrap: "nowrap",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)"
  },
  placeholder: {
    display: "block",
    width: "100%",
    height: "400px",
    "@media (max-width: 959px)": {
      height: "auto",
    },
  },
  profile_title: {
    textAlign: 'center',
    position: 'relative',
    zIndex: '1',
    '&:before': {
      borderTop: '2px solid #dfdfdf',
      content: '',
      margin: '0 auto',
      position: 'absolute',
      top: '50%',
      left: '0',
      right: '0',
      bottom: '0',
      width: '95%'
    }
  },
  help: {
    '&:hover': {
      cursor: 'pointer'
    }
  }
}));

export default useStyles;
